// src/pages/auth/OtpPage.tsx
import { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { OTPInput } from '@/components/ui/OTPInput';
import * as authService from '@/lib/services/auth';

function OTPPageContent() {
  const navigate = useNavigate();

  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function verify() {
    setError(null);
    setIsLoading(true);
    try {
      await authService.verifyOtp(code);
      navigate('/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Verification failed');
    } finally {
      setIsLoading(false);
    }
  }
  return (
    <main
      className="ambient-bg min-h-screen flex items-center justify-center px-6"
    >
      <div className="screen-fade" style={{ width: '100%', maxWidth: 420, position: 'relative', zIndex: 2 }}>
        <header className="text-center mb-10">
          <span className="mono-label">Step 2 of 2</span>
          <h1
            className="font-serif mt-2"
            style={{ fontSize: 36, color: 'var(--text-primary)', letterSpacing: '-0.005em' }}
          >
            Identity Check
          </h1>
          <p
            className="mt-3"
            style={{ color: 'rgba(var(--fg-rgb),0.5)', fontSize: 13, lineHeight: 1.5 }}
          >
            A 6-digit code has been sent to your registered device. Paste or type it below.
          </p>
        </header>

        <OTPInput onComplete={(c) => setCode(c)} />

        <button
          type="button"
          onClick={verify}
          disabled={code.length !== 6 || isLoading}
          className="btn-pill"
          style={{
            width: '100%',
            marginTop: 36,
            opacity: code.length === 6 && !isLoading ? 1 : 0.4,
            cursor: code.length === 6 && !isLoading ? 'pointer' : 'not-allowed',
          }}
        >
          {isLoading ? 'Verifying…' : 'Verify'}
        </button>

        {error && (
          <p
            className="mono-label"
            style={{ marginTop: 10, color: 'var(--color-error)', textAlign: 'center' }}
          >
            {error}
          </p>
        )}

        <div className="flex items-center justify-center mt-4">
          <button
            type="button"
            className="mono-label"
            style={{
              background: 'transparent',
              border: 'none',
              color: 'rgba(var(--fg-rgb),0.45)',
              cursor: 'pointer',
            }}
          >
            Resend Code
          </button>
        </div>

        <footer
          className="mt-16 flex items-center justify-center gap-2 mono-label"
          style={{ color: 'rgba(var(--fg-rgb),0.4)' }}
        >
          <span className="led led-green" />
          Encrypted Tunnel
        </footer>
      </div>
    </main>
  );
}

export default function OTPPage() {
  return (
    <Suspense>
      <OTPPageContent />
    </Suspense>
  );
}
